import * as Client from '@vi-iot/client';

export const rsaIotRoles = [
  Client.RoleGroupType.Admin,
  Client.RoleGroupType.SupportLocal,
  Client.RoleGroupType.SupportInternational,
  Client.RoleGroupType.SupportLocalReadWriteWithRemoteDiagnosis,
  Client.RoleGroupType.SupportInternationalWithRemoteDiagnosis,
];

export function isRsa(iotRole: Client.RoleGroupType): boolean {
  return rsaIotRoles.includes(iotRole);
}
